import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react"
import FullNameAkaSelector from "../FullNameAkaSelector"

import OptionInput from "../OptionInput"

const options = [
    {
        title: "Select",
        key: "",
    },
    {
        title: "Yes",
        key: "yes",
    },
    {
        title: "No",
        key: "no",
    },
]

const HasAnotherNameInput = forwardRef(({ title, data, readOnly }, ref) => {

    const fieldData = data || {
        hasAnotherName: options[0].key,
    }

    const [optionHasAnotherName, setOptionHasAnotherName] = useState(fieldData.hasAnotherName)

    const optionRef = useRef()
    const nameRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const optionResult = optionRef.current.validateAndGetData()
            const fullNameResult = nameRef.current?.validateAndGetData()

            return {
                isValid: optionResult.isValid && (fullNameResult?.isValid ?? true),
                value: {
                    hasAnotherName: optionResult.value,
                    fullName: fullNameResult?.value,
                },
            }
        },
    }))



    return (
        <div className="my-4">

            <OptionInput
                ref={optionRef}
                data={fieldData.hasAnotherName}
                options={options}
                title={title}
                valueChangeHandler={setOptionHasAnotherName}
                readOnly={readOnly}
            />
            {
                optionHasAnotherName === "yes" && (
                    <FullNameAkaSelector
                        ref={nameRef}
                        data={fieldData.fullName}
                        readOnly={readOnly}
                    />
                )
            }
        </div>
    )
})

export default HasAnotherNameInput
